import { DataContext } from "./data-context";
import {
  headerImages,
  section1Data,
  section2Data,
  section3Data,
  section4Image,
  section5Data,
} from "../data";
const DataContextProvider = (props) => {
  return (
    <DataContext.Provider
      value={{
        headerImages,
        section1Data,
        section2Data,
        section3Data,
        section4Image,
        section5Data,
      }}
    >
      {props.children}
    </DataContext.Provider>
  );
};

export default DataContextProvider;
